import ChangePassword from './ChangePassword.page';

export default ChangePassword;
